<template>
    <div class="addblock">
      <h2>Voeg een blok toe:</h2>

      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="btn btn-primary" @click.prevent="createPage('normal', 'Pas deze titel aan')">Tekst</button>
        </span>
      </span>

      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="btn btn-primary" @click.prevent="createPage('image', 'Foto')">Foto</button>
        </span>
      </span>

      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="btn btn-primary" @click.prevent="createPage('doc', 'Lees dit document')">Document</button>
        </span>
      </span>

      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="btn btn-primary">Inleveropdracht <span class="badge badge-light">binnenkort</span></button>
          <!--<button class="btn btn-primary" @click.prevent="createPage('upload', 'Lever je werk in')">Inleveropdracht</button>-->
        </span>
      </span>

      <span>
        <span class="edited_content" v-if="!editmode">
          <button class="btn btn-primary">Film of geluid <span class="badge badge-light">binnenkort</span></button>
          <!--<button class="btn btn-primary" @click.prevent="createPage('media', 'Bekijk dit filmpje')">Film of geluid</button>-->
        </span>
      </span>

    </div>
</template>

<script>  

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
  props:{
    parentpageid: String,
    websiteid: String
  },
  data: function(){
    return{
      editmode: false,
      editmodecols: false,
      editmodecards: false,
      editmodeblog: false,
      pagetitle: ''
    }
  },
  methods: {
    createPage(type, name){

        const requestOptions = {
          headers: authHeader()
        }

        const pageid = ''

        if(this.parentpageid == 'home'){
          //get pageid first
          this.pageid = 'home'
        } else {
          this.pageid = this.parentpageid
        }

        const data = {
          websiteid: this.websiteid,
          belongsto: this.pageid,
          pagetitle: name,
          blockstyle: type
        }

        axios.post(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
        .then(response => {
            this.pagetitle = ''
            this.editmode = false,
            this.editmodecols = false,
            this.editmodecards = false,
            this.$emit('clicked')
        })
        
    }
  }
}
</script>